// src/pdf/styles/invoiceStyles.js

import { StyleSheet } from "@react-pdf/renderer";

// สร้าง styles base (default)
const baseStyles = {
  page: {
    // fontFamily: "InvoiceFont",
    // paddingBottom: 120,
    fontFamily: "Noto Sans Thai",
    backgroundColor: "#FFFFFF",
    // backgroundColor: "#E4E4E4", // close because business need white background
    flexDirection: "column",
  },
  container: { flexDirection: "row", justifyContent: "space-between" },
  column: { width: "48%", borderColor: "#d9d9d9" },
  col: { width: "48%", borderColor: "#d9d9d9" },
  background: {
    // backgroundColor: "#00008B",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    // color: "white",
  },
  section: { margin: 5, padding: 5, flexGrow: 1 },
  text: { fontSize: 16 },
  textMd: { fontSize: 14 },
  textXs: { fontSize: 8 },
  textMs: { fontSize: 12 },
  textXL: { fontSize: 20 },
  textXXL: { fontSize: 26 },
  textLg: { fontSize: 36, fontWeight: "extrabold" },
  textBold: { fontWeight: "extrabold" },
  textWhite: { color: "white" },
  textCenter: { textAlign: "center" },
  textRight: { textAlign: "right" },
  textLeft: { textAlign: "left" },
  table: { display: "table", width: "100%", padding: 1 },
  tableHeader: { backgroundColor: "#00008B" },
  tableBorder: { borderColor: "#000000", borderWidth: 1 },
  tableRowBorderBottom: { borderBottomWidth: 1, borderColor: "#000" },
  tableRowItem: { borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, borderColor: "#000" },
  colDividerLeft: { borderLeftWidth: 1, borderColor: "#000" },
  colDividerRight: { borderRightWidth: 1, borderColor: "#000" },
  tableRow: { flexDirection: "row" },
  tableCell: { padding: 2 },
  tableCellCenter: { textAlign: "center" },
  tableCellRight: { textAlign: "right", paddingRight: 4 },
  padding: { margin: 0, padding: 0 },
  fontChinese: { fontFamily: "ZhuoJianGanLanJianTi Regular" },
  tableCellNoBorder: {
    padding: 5,
    borderBottomWidth: 1,
    borderColor: "#000",
    flex: 1,
  },
  paddingMs: { padding: "5px" },
  image: { width: 50, height: 50 },
  textRightCell: {
    margin: 0,
    marginRight: 2,
    textAlign: "right",
  },
  costRow: { flexDirection: "row" },
  costLabel: { width: "65%" },
  costValue: { width: "35%", padding: 2, textAlign: "right" },
  costLabelIndent: { width: "65%", padding: 2, paddingLeft: 15 },
  infoBoxWhite: {
    // borderWidth: 1,
    // borderColor: "#ffffff", // สีขาว
    // backgroundColor: "#ffffff", // พื้นหลังสีขาว
    // borderRadius: 6,
    padding: 8,
    marginVertical: 6,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)", // เพิ่มเงาเบาๆ (optional)
  },
  infoBoxHeader: {
    flexDirection: "row",
    justifyContent: "center", // จัดกึ่งกลางแนวนอน
    alignItems: "center", // จัดกึ่งกลางแนวตั้ง
    marginBottom: 6,
  },
  infoBoxTitle: {
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  mergedColumn3: {
    width: "60%", // 3 จาก 5 columns ≈ 60%
  },
  singleColumn: {
    width: "20%", // ที่เหลือ 2 ช่อง
  },
  marginLeft: { marginLeft: 5, marginRight: 5 },

  footer: {
    position: "absolute",
    bottom: 10,
    left: 10,
    right: 10,
  },
};

// helper function สร้าง styles table column อัตโนมัติจาก config
export const createTableColumnStyles = (config) => {
  const cols = {};
  Object.entries(config).forEach(([key, width]) => {
    cols[`tableCol${key}`] = {
      width: `${width}%`,
      borderStyle: "solid",
      borderColor: "#d9d9d9",
      padding: 2,
    };
  });
  return cols;
};

// // default invoice table column widths
// const defaultColumnWidths = {
//   NO: 5,
//   DESC: 22,
//   REF: 12,
//   TYPE: 6,
//   CN: 6,
//   KG: 7,
//   L: 6,
//   W: 6,
//   H: 6,
//   CBM: 8,
//   RATE: 8,
//   PRICE: 8,
//   TotalLabel: 27, // merge NO + DESC
// };

// export styles รวม base + table columns
export const createInvoiceStyles = (columnConfig) =>
  StyleSheet.create({
    ...baseStyles,
    ...createTableColumnStyles(columnConfig),
  });
